import Link from 'next/link';
import { PageFrame, PageColumn } from '@/components/layout/PageFrame';

/**
 * The one 404. The app-wide boundary and the storefront's differed only in
 * where the way out goes, and they had drifted into two screens — different
 * heights, one with a rotated button, both written in `text-white`.
 */
export function NotFoundScreen({ href, label }: { href: string; label: string }) {
  return (
    <PageFrame>
      <PageColumn>
        <h1 className="sf-masthead">Hmm, nothing to see here</h1>
        {/* Full width because `.sfv2 .sf-cta` says so — a utility cannot
            narrow it (the class outranks it), and a page arguing with the
            button system is how six hand-rolled buttons happened. */}
        <Link href={href} className="mm-btn sf-cta sf-cta-ink mt-6">
          {label}
        </Link>
      </PageColumn>
    </PageFrame>
  );
}
